import { Group } from "@mantine/core";
import DiscordAuthButton from "./DiscordAuthButton";
import GoogleAuthButton from "./GoogleAuthButton";

const OAuthButtons: React.FC = () => {
  return (
    <Group justify="center">
      <DiscordAuthButton />
      <GoogleAuthButton />
    </Group>
  );
};

export default OAuthButtons;
